import dayjs from "dayjs";
export var SOCIAL_PLATFORM_META = {
    instagram: { icon: "📸", bg: "#fdf0f5", prefix: "instagram.com/" },
    strava: { icon: "🏃", bg: "#fff3ee", prefix: "strava.com/athletes/" },
    youtube: { icon: "▶️", bg: "#fff0f0", prefix: "youtube.com/@" },
    twitter: { icon: "𝕏", bg: "#f5f5f5", prefix: "x.com/" },
    linkedin: { icon: "💼", bg: "#f0f7fb", prefix: "linkedin.com/in/" },
    facebook: { icon: "📘", bg: "#f0f4ff", prefix: "facebook.com/" },
};
export var formatTripCardMeta = function (trip) {
    var start = dayjs(trip.startDate);
    var dateLabel = start.isValid()
        ? start.format("MMM D")
        : trip.startDate;
    var duration = "".concat(trip.durationDays, " day").concat(trip.durationDays !== 1 ? "s" : "");
    var spots = trip.spotsLeft != null ? " \u00B7 ".concat(trip.spotsLeft, " spots left") : "";
    var rating = trip.rating != null ? " \u00B7 \u2605 ".concat(trip.rating) : "";
    return "\uD83D\uDCC5 ".concat(dateLabel, " \u00B7 ").concat(duration).concat(spots).concat(rating);
};
export var getTripCardEmoji = function (name) {
    var lower = name.toLowerCase();
    if (lower.includes("spiti") || lower.includes("ladakh") || lower.includes("mountain"))
        return "🏔️";
    if (lower.includes("goa") || lower.includes("coastal"))
        return "🌊";
    if (lower.includes("trek") || lower.includes("kedarnath"))
        return "🏕️";
    return "🗺️";
};
export var splitFullName = function (fullName) {
    var parts = fullName.trim().split(/\s+/);
    if (parts.length <= 1) {
        return { firstName: parts[0] || "", lastName: "" };
    }
    return {
        firstName: parts[0],
        lastName: parts.slice(1).join(" "),
    };
};
export var socialLinksToMap = function (links) {
    var map = {};
    links.forEach(function (link) {
        map[link.platform] = link.handle || "";
    });
    return map;
};
